import { generalConstants, apiConstants } from '../constants';
import { toast } from '../actions/toast.actions';
import url from '../../helpers/url';

export const loadStudentStatuses = () => ({
    type: apiConstants.API,
    payload: {
        url: url.recipientStatuses,
        request: () => ({ type: generalConstants.LOAD_STUDENT_STATUS_REQUEST }),
        success: (data) => ({ type: generalConstants.LOAD_STUDENT_STATUS_SUCCESS, data }),
        failure: (error) => ({ type: generalConstants.LOAD_STUDENT_STATUS_FAILURE, error }),
        formatData: (data) => ({ ...data[0] }) 
    }
});

export const loadSupportedCurrencies = () => ({
    type: apiConstants.API,
    payload: {
        url: url.supportedCurrencies,
        request: () => ({ type: generalConstants.LOAD_SUPPORTED_CURRENCIES_REQUEST }),
        success: (data) => ({ type: generalConstants.LOAD_SUPPORTED_CURRENCIES_SUCCESS, data }),
        failure: (error) => ({ type: generalConstants.LOAD_SUPPORTED_CURRENCIES_FAILURE, error }),
        formatData: (data) => ({ ...data[0] }) 
    }
});

export const setDebugStatus = (status, noToast) => {
    const { SET_DEBUG_STATUS } = generalConstants;
    return dispatch => {
        dispatch(_request());
        if (!noToast) {
            dispatch(toast({
                intent: 'success',
                message: `${status ? 'Activated' : 'Deactivated'} Debug Mode.`
            }));
        }
    };

    function _request() { return { type: SET_DEBUG_STATUS, data: status }}
}


// WEBPACK FOOTER //
// ./src/redux/actions/general.actions.js